/**
 * Setar ordenes lista
 * @param state
 * @param orders
 */
export function setOrdersCompany(state, orders) {
    state.orders = orders
}

/**
 * Agregar ordenes de empresa
 * @param state
 * @param orders
 */
export function setOrdersByEmploy(state, orders) {
    state.orders = orders
}

/**
 * Actualizar una orden
 * @param state
 * @param orderUpdated
 */
export function updateOrder(state, orderUpdated) {
    const index = state.orders.data.findIndex(item => item.id == orderUpdated.id);
    state.orders.data.splice(index, 1, orderUpdated)
}

/**
 * Cambiar pagina
 * @param state
 * @param per_page
 */
export function changePerPage(state, per_page) {
    state.filter.per_page = per_page;
}

/**
 * Agregar cantidad
 * @param state
 * @param quantity
 */
export function setQuantity(state, quantity) {
    state.quantity = quantity;
}

/**
 * Limpiar filtro
 * @param state
 * @param company_id
 */
export function clearFilter(state, company_id) {
    state.filter = {
        company_id,
        order: null,
        state: null,
        from: null,
        to: null,
        page: 1,
        per_page: 10,
        sortBy: 'id',
        sort: 'DESC',
    }
}

/**
 * Cargar loading
 * @param state
 * @param companies
 */
export function setLoadingDataSelect(state, cargando_datos_select) {
    state.loading_data_select = cargando_datos_select;
}

/**
 * agregar compañias
 * @param state
 * @param companies
 */
export function setCompanyFilter(state, companies) {
    state.companies = companies;
}



/**
 * Agregar ordenes de empresa
 * @param state
 * @param orders
 */
export function setOrder(state, order) {
    state.orderInfo = order
}

